import { useEffect, useState } from "react";

export default function useAddCss({ href }) {
  const [isLoading, setIsLoading] = useState(Boolean(href));

  useEffect(() => {
    if (!href) {
      return null;
    }

    const link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = href;
    link.onload = () => {
      setIsLoading(false);
    };
    document.head.appendChild(link);

    return () => {
      link.remove();
    };
  }, [href]);

  return {
    isLoading,
  };
}
